import { createFileRoute } from "@tanstack/react-router";
import { CORRIDORS, CorridorPage, corridorHead } from "@/lib/corridors";

const corridor = CORRIDORS["essaouira-to-imsouane-taghazout"];

export const Route = createFileRoute("/transfers/essaouira-to-imsouane-taghazout")({
  head: () => corridorHead(corridor),
  component: () => <CorridorPage corridor={corridor} />,
});
